interface ICurrencyEntry {
  currencyCode: string;
  decimalPlaces: number;
}

const CURRENCY_LIST: ICurrencyEntry[] = [
  { currencyCode: "AED", decimalPlaces: 2 },
  { currencyCode: "AFN", decimalPlaces: 2 },
  { currencyCode: "ALL", decimalPlaces: 2 },
  { currencyCode: "AMD", decimalPlaces: 2 },
  { currencyCode: "AOA", decimalPlaces: 2 },
  { currencyCode: "ARS", decimalPlaces: 2 },
  { currencyCode: "AUD", decimalPlaces: 2 },
  { currencyCode: "AWG", decimalPlaces: 2 },
  { currencyCode: "AZN", decimalPlaces: 2 },
  { currencyCode: "BAM", decimalPlaces: 2 },
  { currencyCode: "BBD", decimalPlaces: 2 },
  { currencyCode: "BDT", decimalPlaces: 2 },
  { currencyCode: "BHD", decimalPlaces: 3 },
  { currencyCode: "BIF", decimalPlaces: 0 },
  { currencyCode: "BMD", decimalPlaces: 2 },
  { currencyCode: "BND", decimalPlaces: 2 },
  { currencyCode: "BOB", decimalPlaces: 2 },
  { currencyCode: "BRL", decimalPlaces: 2 },
  { currencyCode: "BSD", decimalPlaces: 2 },
  { currencyCode: "BTN", decimalPlaces: 2 },
  { currencyCode: "BWP", decimalPlaces: 2 },
  { currencyCode: "BYN", decimalPlaces: 2 },
  { currencyCode: "BYR", decimalPlaces: 0 },
  { currencyCode: "BZD", decimalPlaces: 2 },
  { currencyCode: "CAD", decimalPlaces: 2 },
  { currencyCode: "CDF", decimalPlaces: 2 },
  { currencyCode: "CHF", decimalPlaces: 2 },
  { currencyCode: "CLP", decimalPlaces: 0 },
  { currencyCode: "CNY", decimalPlaces: 2 },
  { currencyCode: "COP", decimalPlaces: 2 },
  { currencyCode: "CRC", decimalPlaces: 2 },
  { currencyCode: "CUP", decimalPlaces: 2 },
  { currencyCode: "CVE", decimalPlaces: 2 },
  { currencyCode: "CYP", decimalPlaces: 2 },
  { currencyCode: "CZK", decimalPlaces: 2 },
  { currencyCode: "DJF", decimalPlaces: 0 },
  { currencyCode: "DKK", decimalPlaces: 2 },
  { currencyCode: "DOP", decimalPlaces: 2 },
  { currencyCode: "DZD", decimalPlaces: 2 },
  { currencyCode: "EGP", decimalPlaces: 2 },
  { currencyCode: "ERN", decimalPlaces: 2 },
  { currencyCode: "ETB", decimalPlaces: 2 },
  { currencyCode: "EUR", decimalPlaces: 2 },
  { currencyCode: "FJD", decimalPlaces: 2 },
  { currencyCode: "FKP", decimalPlaces: 2 },
  { currencyCode: "GBP", decimalPlaces: 2 },
  { currencyCode: "GEL", decimalPlaces: 2 },
  { currencyCode: "GHS", decimalPlaces: 2 },
  { currencyCode: "GIP", decimalPlaces: 2 },
  { currencyCode: "GMD", decimalPlaces: 2 },
  { currencyCode: "GNF", decimalPlaces: 0 },
  { currencyCode: "GTQ", decimalPlaces: 2 },
  { currencyCode: "GYD", decimalPlaces: 2 },
  { currencyCode: "HKD", decimalPlaces: 2 },
  { currencyCode: "HNL", decimalPlaces: 2 },
  { currencyCode: "HRK", decimalPlaces: 2 },
  { currencyCode: "HTG", decimalPlaces: 2 },
  { currencyCode: "HUF", decimalPlaces: 2 },
  { currencyCode: "IDR", decimalPlaces: 2 },
  { currencyCode: "ILS", decimalPlaces: 2 },
  { currencyCode: "INR", decimalPlaces: 2 },
  { currencyCode: "IQD", decimalPlaces: 3 },
  { currencyCode: "IRR", decimalPlaces: 2 },
  { currencyCode: "ISK", decimalPlaces: 0 },
  { currencyCode: "JMD", decimalPlaces: 2 },
  { currencyCode: "JOD", decimalPlaces: 3 },
  { currencyCode: "JPY", decimalPlaces: 0 },
  { currencyCode: "KES", decimalPlaces: 2 },
  { currencyCode: "KGS", decimalPlaces: 2 },
  { currencyCode: "KHR", decimalPlaces: 2 },
  { currencyCode: "KMF", decimalPlaces: 0 },
  { currencyCode: "KPW", decimalPlaces: 2 },
  { currencyCode: "KRW", decimalPlaces: 0 },
  { currencyCode: "KWD", decimalPlaces: 3 },
  { currencyCode: "KYD", decimalPlaces: 2 },
  { currencyCode: "KZT", decimalPlaces: 2 },
  { currencyCode: "LAK", decimalPlaces: 2 },
  { currencyCode: "LBP", decimalPlaces: 2 },
  { currencyCode: "LKR", decimalPlaces: 2 },
  { currencyCode: "LRD", decimalPlaces: 2 },
  { currencyCode: "LSL", decimalPlaces: 2 },
  { currencyCode: "LTL", decimalPlaces: 2 },
  { currencyCode: "LVL", decimalPlaces: 2 },
  { currencyCode: "LYD", decimalPlaces: 3 },
  { currencyCode: "MAD", decimalPlaces: 2 },
  { currencyCode: "MDL", decimalPlaces: 2 },
  { currencyCode: "MGA", decimalPlaces: 2 },
  { currencyCode: "MKD", decimalPlaces: 2 },
  { currencyCode: "MMK", decimalPlaces: 2 },
  { currencyCode: "MNT", decimalPlaces: 2 },
  { currencyCode: "MOP", decimalPlaces: 2 },
  { currencyCode: "MRU", decimalPlaces: 2 },
  { currencyCode: "MUR", decimalPlaces: 2 },
  { currencyCode: "MVR", decimalPlaces: 2 },
  { currencyCode: "MWK", decimalPlaces: 2 },
  { currencyCode: "MXN", decimalPlaces: 2 },
  { currencyCode: "MYR", decimalPlaces: 2 },
  { currencyCode: "MZN", decimalPlaces: 2 },
  { currencyCode: "NAD", decimalPlaces: 2 },
  { currencyCode: "NGN", decimalPlaces: 2 },
  { currencyCode: "NIO", decimalPlaces: 2 },
  { currencyCode: "NOK", decimalPlaces: 2 },
  { currencyCode: "NPR", decimalPlaces: 2 },
  { currencyCode: "NZD", decimalPlaces: 2 },
  { currencyCode: "OMR", decimalPlaces: 3 },
  { currencyCode: "PAB", decimalPlaces: 2 },
  { currencyCode: "PEN", decimalPlaces: 2 },
  { currencyCode: "PGK", decimalPlaces: 2 },
  { currencyCode: "PHP", decimalPlaces: 2 },
  { currencyCode: "PKR", decimalPlaces: 2 },
  { currencyCode: "PLN", decimalPlaces: 2 },
  { currencyCode: "PYG", decimalPlaces: 0 },
  { currencyCode: "QAR", decimalPlaces: 2 },
  { currencyCode: "RON", decimalPlaces: 2 },
  { currencyCode: "RSD", decimalPlaces: 2 },
  { currencyCode: "RUB", decimalPlaces: 2 },
  { currencyCode: "RWF", decimalPlaces: 0 },
  { currencyCode: "SAR", decimalPlaces: 2 },
  { currencyCode: "SBD", decimalPlaces: 2 },
  { currencyCode: "SCR", decimalPlaces: 2 },
  { currencyCode: "SDG", decimalPlaces: 2 },
  { currencyCode: "SEK", decimalPlaces: 2 },
  { currencyCode: "SGD", decimalPlaces: 2 },
  { currencyCode: "SHP", decimalPlaces: 2 },
  { currencyCode: "SIT", decimalPlaces: 2 },
  { currencyCode: "SOS", decimalPlaces: 2 },
  { currencyCode: "SRD", decimalPlaces: 2 },
  { currencyCode: "SSP", decimalPlaces: 2 },
  { currencyCode: "STN", decimalPlaces: 2 },
  { currencyCode: "SVC", decimalPlaces: 2 },
  { currencyCode: "SYP", decimalPlaces: 2 },
  { currencyCode: "SZL", decimalPlaces: 2 },
  { currencyCode: "THB", decimalPlaces: 2 },
  { currencyCode: "TJS", decimalPlaces: 2 },
  { currencyCode: "TMT", decimalPlaces: 2 },
  { currencyCode: "TND", decimalPlaces: 3 },
  { currencyCode: "TOP", decimalPlaces: 2 },
  { currencyCode: "TRY", decimalPlaces: 2 },
  { currencyCode: "TTD", decimalPlaces: 2 },
  { currencyCode: "TWD", decimalPlaces: 2 },
  { currencyCode: "TZS", decimalPlaces: 2 },
  { currencyCode: "UAH", decimalPlaces: 2 },
  { currencyCode: "UGX", decimalPlaces: 0 },
  { currencyCode: "USD", decimalPlaces: 2 },
  { currencyCode: "UYU", decimalPlaces: 2 },
  { currencyCode: "UZS", decimalPlaces: 2 },
  { currencyCode: "VES", decimalPlaces: 2 },
  { currencyCode: "VND", decimalPlaces: 0 },
  { currencyCode: "VUV", decimalPlaces: 0 },
  { currencyCode: "WST", decimalPlaces: 2 },
  { currencyCode: "XAF", decimalPlaces: 0 },
  { currencyCode: "XCD", decimalPlaces: 2 },
  { currencyCode: "XCG", decimalPlaces: 2 },
  { currencyCode: "XOF", decimalPlaces: 0 },
  { currencyCode: "XPF", decimalPlaces: 0 },
  { currencyCode: "YER", decimalPlaces: 2 },
  { currencyCode: "ZAR", decimalPlaces: 2 },
  { currencyCode: "ZWL", decimalPlaces: 2 },
];

const DEFAULT_DECIMAL_PLACES = 2;

// Pre-built lookup for O(1) access
const DECIMAL_PLACES_MAP = new Map<string, number>(
  CURRENCY_LIST.map(({ currencyCode, decimalPlaces }) => [
    currencyCode,
    decimalPlaces,
  ]),
);

export function getDecimalPlaces(currencyCode: string): number {
  return (
    DECIMAL_PLACES_MAP.get(currencyCode.toUpperCase()) ?? DEFAULT_DECIMAL_PLACES
  );
}

export function getDivisor(currencyCode: string): number {
  return Math.pow(10, getDecimalPlaces(currencyCode));
}
